import { AwardsGallery } from '@commons/AwardsGallery/AwardsGallery';
import { initMerchantSearch } from "@commons/MerchantSearch";
import { ImageGallery } from '@commons/ImageGallery/ImageGallery';



// mark js as enabled for css
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

window.AwardsGallery = AwardsGallery;
window.ImageGallery = ImageGallery;
window.initMerchantSearch = initMerchantSearch;

import autosize from "autosize";
window.autosize = autosize;

import anime from 'animejs';
window.anime = anime;

// Is needed for magnific-popup outside Webpack-Context
import 'magnific-popup';


// global Plyr - make it available for jQuery plugins that are not processed by webpack
import Plyr from "plyr";
window.Plyr = Plyr;
// Set default iconUrl - this will be used if data-plyr-icon-url is not set on the element
window.Plyr.defaults = {
    settings: []
};
